// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
export const timeseriesSeriesId = (z.string());
export const timeseriesSeries = z.object({
    id: timeseriesSeriesId,
    unit: z.string().nullable(),
    created_at: z.date(),
});
export const timeseriesSeriesInitializer = z.object({
    id: timeseriesSeriesId.optional(),
    unit: z.string().optional().nullable(),
    created_at: z.date().optional(),
});
export const timeseriesSeriesMutator = z.object({
    id: timeseriesSeriesId.optional(),
    unit: z.string().optional().nullable(),
    created_at: z.date().optional(),
});
//# sourceMappingURL=TimeseriesSeries.js.map